import React from "react";

import ClientStrategyPage from "containers/admin/clients/client/components/client-strategy-page/client-strategy-page";
import { getProgramStrategyCategory, type ProgramStrategyType } from "api/program-strategy-schema";

export type ProgramStrategyPageConfig = {
  programStrategyType: ProgramStrategyType;
  formId: string;
  headerTitle: string;
  breadcrumbLabel: string;
};

const ProgramStrategyPage: React.FC<ProgramStrategyPageConfig> = ({
  programStrategyType,
  formId,
  headerTitle,
  breadcrumbLabel,
}) => (
  <ClientStrategyPage
    strategyCategory={getProgramStrategyCategory(programStrategyType)}
    formId={formId}
    sidebarSectionId="programs-nav"
    emptyMessage="Program strategy template is not available."
    saveSuccessTitle="Program strategy saved"
    saveErrorTitle="Could not save program strategy"
    editButtonLabel="Edit strategy"
    header={{ title: headerTitle, showFiscalYearBadge: true }}
    breadcrumb={{
      parents: [
        { label: "Strategy", active: false },
        { label: "Programs", active: false },
      ],
      label: breadcrumbLabel,
      includeActiveTab: false,
    }}
  />
);

export default ProgramStrategyPage;
